<!-- Search classroom starts here -->
<div class="container-fluid bg-color py-3">
    <div class="row">
        <div class="d-flex align-items-center flex-wrap gap-3 ms-2">
            <div class="search-container">
                <input matInput placeholder="search your classrooms here ..." [(ngModel)]="searchQuery"
                    class="form-control" />
                <mat-icon class="search-icon">search</mat-icon>
            </div>
            <button class="responsive-btn" (click)="openJoinDialogBox()">
                <mat-icon>person_add</mat-icon>
                <span class="btn-text">Join Classroom</span>
            </button>
            <div class="notification-section">
                <div class="notification-icon-container">
                    <img src="assets/images/bell_notification.svg" alt="notification" class="notification-icon"
                        (click)="openNotifications()" />
						 <span class="notification-badge" *ngIf="totalNotifications > 0"(click)="markAllNotificationsRead()">{{ totalNotifications }}</span>
						<div class="notification-slider" [class.open]="isNotificationOpen">
				<div class="notifications-content">	
			<app-notifications (totalCountChanged)="updateTotalNotifications($event)" 
			  (closeSlider)="openNotifications()" [isSliderMode]="true" [source]="'home'"></app-notifications>
		 </div>
	<hr/>
  <a href="student-dashboard/notification" class="sticky-footer">View All</a>
</div>
</div>

	<button class="profile-btn" (click)="toggleProfileMenu()">
	<img src="assets/images/avatar.png" alt="avatar" class="profile-circle" />
    </button>

	<div class="profile-dropdown" *ngIf="isProfileMenuOpen">
  <div class="profile-header" *ngIf="userDetail">
    <p class="name">{{ userDetail.first_name }} {{userDetail.last_name}}</p>
    <p class="email" [matTooltip]="userDetail.phone_email">
		{{ userDetail.phone_email.length > 20 ? (userDetail.phone_email | slice: 0 :20) + '...' :userDetail.phone_email }}</p>
  </div>

		<div class="divider"></div>

  <button class="menu-item" routerLink="/student-dashboard/profile">
	<i class="bi bi-person"></i>
    <span>My Profile</span>
  </button>

   <button class="menu-item" (click)="openPaymentHistory()">
    <i class="bi bi-credit-card"></i>
    <span>Payment History</span>
  </button> 
  <app-payment-history-home *ngIf="isPaymentHistoryOpen" (close)="closePaymentHistory()"></app-payment-history-home>

   <button class="menu-item">
    <i class="bi bi-question-circle"></i>
    <span>Help & Support</span>
  </button>

  <div class="divider"></div>

  <button class="menu-item logout" (click)="logout()">
    <i class="bi bi-box-arrow-right"></i>
    <span>Logout</span>
  </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid bg-color">
    <div class="row">
        <div class="col-lg-12 col-md-12">
            <div class="main-content ms-2">
                <div class="d-flex justify-content-around row mb-4">
                    <div class="col-lg-8 col-md-8 my-4">
                        <h2>Welcome, {{ getFullName() }}!</h2>
                        <span>Ready to learn? Join classrooms, explore new courses, or take quizzes today!</span>
                        <button class="my-classes-btn mt-2" (click)="goToClasses()">
                            <img src="assets/images/student_myclass_btn.svg" alt="my classes icon"
                                class="my-classes-icon" />
                            <span class="my-classes-text">My Classes</span>
                        </button>
                    </div>
                    <div class="col-lg-4 col-md-4 d-flex justify-content-center img-cont">
                        <img src="assets/images/studentbanner.png" alt="image" />
                    </div>
                </div>
            </div>

            <!-- Dashboard Cards -->
            <div class="container">
                <div class="row">
                    <div class="col-lg-3 col-md-3 my-4 d-flex justify-content-between"
                        *ngFor="let classData of cardData">
                        <div class="dashboard-card">
                            <div class="card-content">
                                <div class="card-text">
                                    <h4>{{ classData.title || "N/A" }}</h4>
                                    <h2>{{ classData.studentcount || "N/A" }}</h2>
                                </div>
                                <div class="card-icon-container">
                                    <img [src]="classData.image" alt="icon" class="card-icon" />
                                </div>
                            </div>
                            <div class="card-footer">
                                <p class="card-subtext">{{ classData.subtext || "N/A" }}</p>
                            </div>							
                <h6 class="view-link" [ngClass]="{ 'extra-margin': classData.title === 'Active Classrooms' }"
                  (click)="onViewClick(classData.title); $event.stopPropagation()">
                  View
                </h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>